import { TextField } from 'components';
import { getIsTouchDevice } from '@/utils';
import { useMediaQuery } from '@/hooks';
import { Pregunta, SurveyStepsHandler } from '@/hooks/useSurvey';

interface TextTareaStepProps {
    step: Pregunta;
    handleSurveySteps: SurveyStepsHandler;
    iStep: number;
}

const TextTareaStep = ({ step, handleSurveySteps, iStep }: TextTareaStepProps) => {
    const isTouchDevice = getIsTouchDevice();
    const xs = useMediaQuery('(min-width: 500px)');
    const error = step.cRespuesta ? step.cRespuesta.length > 1000 : false;

    return (
        <div className="flex flex-col pr-1.5">
            <div
                className={`
                    ${isTouchDevice && xs ? 'flex justify-center' : ''}
                    ${isTouchDevice ? 'pb-10' : 'pb-2.5'}
                `}
            >
                <strong
                    className={`
                        ${isTouchDevice ? (xs ? 'text-[27px]' : 'text-xl') : 'text-lg'}
                        ${isTouchDevice ? 'text-center' : 'text-right'}
                    `}
                >
                    {step.cPregunta}
                </strong>
            </div>
            <TextField
                helperText={error ? 'Excede los 1000 caracteres.' : null}
                error={error}
                handleValue={(value) => handleSurveySteps(iStep, 'cValor', value)}
                value={step.cValor ? step.cValor : ''}
            />
        </div>
    );
};

export default TextTareaStep;
